import { BeakerIcon } from '@heroicons/react/24/outline';
import { PageHeader } from '../components/PageHeader';
import { ErrorMessage, Field, FieldGroup, Fieldset, Label } from '../catalyst/fieldset';
import { Input } from '../catalyst/input';
import { Button } from '../catalyst/button';
import { useNavigate } from 'react-router-dom';
import backend from '../services/backend';
import { useToast } from '../components/Toast';
import { useForm, type SubmitHandler } from 'react-hook-form';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

type FormData = {
  name: string;
};

export default function CategoryCreate() {
  useDocumentTitle('Create Category');
  const navigate = useNavigate();
  const toast = useToast();
  const form = useForm<FormData>({
    defaultValues: {
      name: '',
    },
  });

  const onSubmit: SubmitHandler<FormData> = async (data) => {
    const response = await backend.createCategory(data.name);
    toast.success('Category created successfully');
    navigate(`/categories/${response.data.id}`);
  };

  return (
    <>
      <PageHeader
        showBackButton={true}
        title="Create Category"
        description="Create a new category"
        icon={<BeakerIcon className="size-6" />}
      ></PageHeader>

      <form className="max-w-md mx-auto space-y-8" onSubmit={form.handleSubmit(onSubmit)}>
        <Fieldset>
          <FieldGroup>
            <Field>
              <Label>Category name</Label>
              <Input
                placeholder="Enter category name"
                {...form.register('name', {
                  required: 'Name is required',
                  minLength: {
                    value: 5,
                    message: 'Name must be at least 5 characters long',
                  },
                })}
              />
              {form.formState.errors.name && (
                <ErrorMessage className="text-red-500">{form.formState.errors.name.message}</ErrorMessage>
              )}
            </Field>
          </FieldGroup>
        </Fieldset>

        <div className="flex justify-end gap-2">
          <Button type="button" plain onClick={() => navigate(-1)} disabled={form.formState.isSubmitting}>
            Cancel
          </Button>
          <Button type="submit" disabled={form.formState.isSubmitting}>
            {form.formState.isSubmitting ? 'Creating...' : 'Create'}
          </Button>
        </div>
      </form>
    </>
  );
}
